/* eslint-disable */
export default {
  save: '保存',
} as const;

// @key: @#@"save"@#@ @source: @#@"Save"@#@
